import type { ReferenceDisplayTransform } from '@seen/core/display'
import { resolveId } from '@seen/core/references'
import { demoParticipantLabel } from '#src/demo-mode/demoNumbers.ts'
import {
  recordHiddenName,
  scrubKnownNames,
} from '#src/demo-mode/scrubKnownNames.ts'

// A Patient label becomes "Participant N"; any other label keeps its text with
// the participant names demo mode already hid replaced.
export const demoReferenceDisplay: ReferenceDisplayTransform = (
  label,
  reference
) => {
  const participantId = reference.reference?.startsWith('Patient/')
    ? resolveId(reference)
    : undefined
  if (participantId) {
    recordHiddenName(participantId, [label])
    return demoParticipantLabel(participantId)
  }
  return scrubKnownNames(label)
}
